import UploadAdapter from '../uploadAdapter';

export default function MyCustomUploadAdapterPlugin(editor) {
  const { board } = editor.config._config;

  editor.plugins.get('FileRepository').createUploadAdapter = loader => {
    return new UploadAdapter(loader, board); // board 값을 전달
  };
}
